import { v4 as uuid } from 'uuid'

class FormBuilderRow {
  constructor(
    { section, id, questions, order },
    isNew = true,
    hasChanged = false
  ) {
    this.section = section ?? uuid()
    this.id = id ?? uuid()
    this.questions = questions ?? []
    this.isNew = isNew
    this.order = order
    this.hasChanged = hasChanged
  }
}

export default FormBuilderRow
